<template>
	<ReservationsTimeline v-if="roomsOrdersStore.reservationsViewMode === 'timeline'" v-bind="$attrs" />
	<ReservationView v-else v-bind="$attrs" />
</template>

<script>
import {useRoomsOrdersStore} from "@/console-new/stores";
import {useUserStore} from "@/user/stores";
import ReservationView from "@/console-new/components/ops/tables/ReservationView.vue";
import ReservationsTimeline from "@/console-new/components/ops/tables/ReservationsTimeline.vue";

export default {
	name: "OpsReservationsContainer",
	inheritAttrs: false,
	components: {ReservationView, ReservationsTimeline},
	setup() {
		const roomsOrdersStore = useRoomsOrdersStore();
		const userStore = useUserStore();
		return {roomsOrdersStore, userStore};
	},
	computed: {
		waitlistEnabled() {
			return !!(this.userStore.currBusiness && Number(this.userStore.currBusiness.reservations_waitlist));
		},
	},
	methods: {
		refreshWaitlist() {
			if(this.waitlistEnabled && this.userStore.currBusinessId !== null) {
				this.roomsOrdersStore.getDayWaitlist();
			}
		},
	},
	mounted() {
		this.refreshWaitlist();
	},
	watch: {
		"roomsOrdersStore.reservationsSelectedDate": function (newVal, oldVal) {
			if (newVal !== oldVal) {
				this.refreshWaitlist();
			}
		},
		"userStore.currBusinessId": function (newVal, oldVal) {
			if (newVal !== null && newVal !== oldVal) {
				this.refreshWaitlist();
			}
		},
	},
};
</script>
